import Blockchain from '../models/Blockchain.enum';
import { Chain } from '../api/enum_pb';

const DTO_TO_MODEL_MAP = {
  [Chain.CHAIN_UNKNOWN]: Blockchain.UNKNOWN,
  [Chain.CHAIN_SOLANA]: Blockchain.SOLANA,
  [Chain.CHAIN_ETHEREUM]: Blockchain.ETHEREUM,
};

const MODEL_TO_DTO_MAP = {
  [Blockchain.UNKNOWN]: Chain.CHAIN_UNKNOWN,
  [Blockchain.SOLANA]: Chain.CHAIN_SOLANA,
  [Blockchain.ETHEREUM]: Chain.CHAIN_ETHEREUM,
};

const mapper = {
  fromDto: (blockchain: Chain): Blockchain => DTO_TO_MODEL_MAP[blockchain],
  toDto: (blockchain: Blockchain): Chain => MODEL_TO_DTO_MAP[blockchain],
};

export default mapper;
